import { Controller } from "@hotwired/stimulus"
import { matchesFilter, snsAliasText, splitList } from "../lib/lp_catalog_filter"

// LPの機能一覧(/product)で、目的・SNS・キーワードでカードをその場で絞り込む。
// 絞り込みの操作部品(controls)は hidden で描画しておき、JSが動いたときだけ表示する
// (JSが無効な環境では操作部品を出さず、全カードをそのまま見せる)。
export default class extends Controller {
  static targets = ["controls", "input", "list", "item", "empty", "count", "purposeButton", "snsButton"]

  connect() {
    this.purpose = ""
    this.sns = ""
    this.controlsTargets.forEach((element) => { element.hidden = false })
    this.syncPressed()
    this.apply()
  }

  selectPurpose(event) {
    this.purpose = String(event.params.value ?? "")
    this.syncPressed()
    this.apply()
  }

  selectSns(event) {
    this.sns = String(event.params.value ?? "")
    this.syncPressed()
    this.apply()
  }

  search() {
    this.apply()
  }

  reset() {
    this.purpose = ""
    this.sns = ""
    if (this.hasInputTarget) this.inputTarget.value = ""
    this.syncPressed()
    this.apply()
  }

  apply() {
    const query = this.hasInputTarget ? this.inputTarget.value : ""
    let visibleCount = 0

    this.itemTargets.forEach((item) => {
      const sns = splitList(item.dataset.sns)
      const matched = matchesFilter(
        {
          purposes: splitList(item.dataset.purposes),
          sns,
          text: `${item.textContent} ${item.dataset.searchText || ""} ${snsAliasText(sns)}`,
        },
        { purpose: this.purpose, sns: this.sns, query },
      )
      item.hidden = !matched
      if (matched) visibleCount++
    })

    if (this.hasCountTarget) this.countTarget.textContent = String(visibleCount)
    if (this.hasEmptyTarget) this.emptyTarget.hidden = visibleCount > 0
    // 0件のときはカードの一覧(空の ul の余白)ごと隠す
    if (this.hasListTarget) this.listTarget.hidden = visibleCount === 0
  }

  syncPressed() {
    this.purposeButtonTargets.forEach((button) => {
      button.setAttribute("aria-pressed", String((button.dataset.lpCatalogFilterValueParam || "") === this.purpose))
    })
    this.snsButtonTargets.forEach((button) => {
      button.setAttribute("aria-pressed", String((button.dataset.lpCatalogFilterValueParam || "") === this.sns))
    })
  }
}
